import React, { useState } from 'react'
import { Drawer, Menu, Dropdown } from 'antd'
import moment from 'moment'
import Select from 'react-select'
import { Route, Switch, useHistory, Link } from 'react-router-dom'

import { useListData, useToggle, stringifyDate, usePet } from '../../modules'

import DateRangePicker from '../reusable/rangePicker'
import Receive from '../reusable/receive'

import NewCoding from './newCoding'
import Patient from '../reusable/patient'

const OrderItems = ({ department, path }) => {
    const [string, setString] = useState('')
    const [categories, setCategories] = useState([])
    const [category, setCategory] = useState({ label: 'Doctor', value: 'Doctor' })
    const [ranges, setRanges] = useState([moment().startOf('day'), moment().endOf('day')])
    const history = useHistory()

    const [visible, toggleVisible] = useToggle(true)
    const [notSeen, toggleNSeen] = useToggle(true)

    const close = () => {
        toggleVisible()
        // onClose()
        setTimeout(() => history.goBack(), 300)
    }

    const [{ loading: sLoading, error: sError }] = usePet('routingGroupNames', { hidden: false }, { notify: true, callback: ({ data }) => setCategories(data), logOutOnError: true })

    const [
        { loading: qLoading, error: qError, fetch: fetchBillItems },
        { list: queue },
        { page = 1, limit = 10, navigate, Paginate }
    ] = useListData('codingBilledItems', ranges ? { 
        notCoded: true,
        department,
        routingGroup: category?.label,
        string, 
        paidOnly: true,
        from: ranges[0]?._d ?? null, 
        to: ranges[1]?._d ?? null,
        order: notSeen ? 1 : -1
    } : { notCoded: true, string, department, paidOnly: true, order: notSeen ? 1 : -1 }, { notify: true }, 'items')

    const refresh = () => {
        navigate(1)
        fetchBillItems()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const onCategoryChange = ct => {
        setCategory(ct)
        refresh()
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            width="60%">
            <p className="font-extrabold text-3xl mb-0">{ department } Visits</p>
            <div className="sm:flex sm:justify-between sm:items-center mt-3 mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Patient Name, OP/IP No." />
                <Select
                    inputId="single-select-example"
                    className="single-select w-60"
                    classNamePrefix="react-select"
                    onChange={ onCategoryChange }
                    value={ category }
                    options={ categories.map(cat => ({ label: cat, value: cat })) }
                    placeholder="Choose Category" />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <DateRangePicker selectRange={selectRange} ranges={ ranges } />
                </div>
            </div>
            <div className="mb-8">
                <Receive
                    progress
                    loading={qLoading}
                    error={qError}>
                    {
                        queue?.length > 0 ?
                            <table className="table-auto w-full">
                                {/* Table header */}
                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                    <tr>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">No.</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Patient Name</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Item</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Date</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center"></div>
                                        </th>
                                    </tr>
                                </thead>
                                {/* Table body */}
                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                    {
                                        queue.map((item, key) =>
                                            <tr>
                                                <td className="p-2">
                                                    <div className="text-center">
                                                        { ((page - 1) * limit) + (key + 1) }.
                                                    </div>
                                                </td>
                                                <td className="p-2">
                                                    <Patient patient={ item?.patient } />
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-left">{ item.ref?.name ?? item.name }{ item.quantity > 1 && ` (x ${item.quantity})` }</div>
                                                    <div className="flex space-x-2 pl-1 items-center">
                                                        <div className={ `w-2 h-2 rounded-full bg-${ item.seen? 'green' : item.discarded ? 'gray' : 'yellow'}-500 shadow` }></div>
                                                        <p className={ `text-${ item.seen? 'green' : item.discarded ? 'gray' : 'yellow'}-500 text-xs italic mb-0` }>{ item.seen? 'Seen' : item.discarded ? 'Discarded' : 'Pending' }</p>
                                                    </div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{stringifyDate(item.date)}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">
                                                        <Link to={ `${path}/new/${item?._id}` }>
                                                            <button className="text-white hisani-btn-green-light font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center">View</button>
                                                        </Link>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        :
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">No patients { string.trim().length > 2 ? `matching "${string}"` : "" } were found</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
            <Switch>
                <Route path={ `${path}/new/:id` }>
                    <NewCoding onComplete={ refresh } department={ department } path={ `${path}/new` } />
                </Route>
            </Switch>
        </Drawer>
    )
}

export default OrderItems